var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfo = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.2505C16.5537 20.2505 20.25 16.5541 20.25 11.9999C20.25 7.44572 16.5537 3.74927 12 3.74927C7.44626 3.74927 3.75 7.44572 3.75 11.9999C3.75 16.5541 7.44626 20.2505 12 20.2505ZM12 21.0005C16.968 21.0005 21 16.9682 21 11.9999C21 7.03155 16.968 2.99927 12 2.99927C7.032 2.99927 3 7.03155 3 11.9999C3 16.9682 7.032 21.0005 12 21.0005Z",
    fill: "#00338E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5771 10.8092C12.5771 10.669 12.5006 10.5925 12.3604 10.5925H11.3531C11.2129 10.5925 11.1236 10.669 11.1236 10.8092L10.9579 16.2407C10.9579 16.3937 11.0216 16.4575 11.1619 16.4575H12.5261C12.6664 16.4575 12.7301 16.3937 12.7301 16.2407L12.5771 10.8092Z",
    fill: "#00338E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0361 8.65448C13.0361 8.04248 12.5516 7.54523 11.8759 7.54523C11.2001 7.54523 10.7029 8.04248 10.7029 8.65448C10.7029 9.26648 11.2766 9.75098 11.8759 9.75098C12.4751 9.75098 13.0361 9.26648 13.0361 8.65448Z",
    fill: "#00338E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info.c19893e3826de44164e731b655fcbe29.svg";